import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { UserDto } from '@cloudcost/shared-types/users';

interface DeleteUserDialogProps {
  open: boolean;
  onClose: () => void;
  user: UserDto | null;
  onConfirm: () => void;
}

export const DeleteUserDialog: React.FC<DeleteUserDialogProps> = ({
  open,
  onClose,
  user,
  onConfirm,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="delete-user-dialog-title"
      aria-describedby="delete-user-dialog-description"
    >
      <DialogTitle id="delete-user-dialog-title">
        Remove Tech User from Cloud Account
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="delete-user-dialog-description">
          Are you sure you want to remove {user?.username} from this cloud account? 
          This action will revoke their access to this cloud account.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onConfirm} color="error" autoFocus>
          Remove User
        </Button>
      </DialogActions>
    </Dialog>
  );
};